module.exports = __webpack_public_path__ + "static/media/AroundMe.05d5572f.png";